<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_lable_search') ||
                  '异常联络单号/业务人员/供应商/客户 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.table_label_status') || '单据状态'">
              <el-checkbox-group v-model="form.listMaterialAbnormalStatus">
                <el-checkbox label="N">{{
                  $l('INDEX.form_label_status_draft') || '草稿'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('INDEX.order_status_submitted_OA') || '已提交OA'
                }}</el-checkbox>
                <el-checkbox label="R">{{
                  $l('INDEX.order_status_R') || '已驳回'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.order_status_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.order_status_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_processingStatus') || '业务处理状态'">
              <el-checkbox-group v-model="form.listProcessingStatus">
                <el-checkbox label="Y">{{
                  $l('form_label_processingStatus_Y') || '已处理'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('form_label_processingStatus_N') || '未处理'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_confirmStatus') || '财务确认状态'">
              <el-checkbox-group v-model="form.listConfirmStatus">
                <el-checkbox label="Y">{{
                  $l('form_label_confirmStatus_Y') || '已确认'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('form_label_confirmStatus_N') || '未确认'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_materialAbnormalNo') || '异常联络单号'"
            >
              <el-input
                v-model.trim="form.materialAbnormalNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_abnormal_procurement') || '超采原因'"
            >
              <dict-select
                v-model="form.listAbnormalProcurement"
                url="/master/common/dict/biz"
                :body="abnormalProcurementParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('table_label_costParty') || '费用承担方'">
              <dict-select
                v-model="form.listCostParty"
                url="/master/common/dict/biz"
                :body="costPartyParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_deductionMethod') || '费用处理方式'"
            >
              <dict-select
                v-model="form.deductionMethod"
                url="/master/common/dict/biz"
                :body="deductionMethodParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.purchase_form_label_scmName') || '供应商'"
            >
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/allScmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_cust') || '订单客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_requestDate') || '申请日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.requestDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.requestDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_expected_date') || '预计处理日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.expectedDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="expectedDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.expectedDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="expectedDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_actual_date') || '实际处理日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.actualDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="actualDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.actualDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="actualDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_fin_confirm_date') || '确认日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.finConfirmDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="finConfirmDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.finConfirmDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="finConfirmDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listMaterialAbnormalStatus: ['N', 'S', 'R', 'Y'],
  listProcessingStatus: [],
  listConfirmStatus: [],
}
export default {
  data() {
    return {
      abnormalProcurementParams: { dictType: 'abnormalProcurement' },
      costPartyParams: { dictType: 'costParty' },
      deductionMethodParams: { dictType: 'deductionMethod' },

      materialAbnormalStatusParams: { dictType: 'materialAbnormalStatus' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      expensePayerParams: { dictType: 'expensePayer' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      bankAccountOptions: [
        {
          label: this.$l('INDEX.form_label_company') || '公司',
          value: '0',
        },
        {
          label: this.$l('INDEX.form_label_personal') || '个人',
          value: '1',
        },
      ],
      //预计处理日期
      expectedDateStartPicker: this.expectedDateEnd(),
      expectedDateEndPicker: this.expectedDateStart(),
      //实际处理日期
      actualDateStartPicker: this.actualDateEnd(),
      actualDateEndPicker: this.actualDateStart(),
      //财务确认日期
      finConfirmDateStartPicker: this.finConfirmDateEnd(),
      finConfirmDateEndPicker: this.finConfirmDateStart(),

      //申请日期限制
      requestDateStartPicker: this.requestDateEnd(),
      requestDateEndPicker: this.requestDateStart(),

      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),
      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'personal-userMaterialAbnormal-detail',
        params: { ...params, pageType },
      })
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    requestDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.requestDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.requestDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    requestDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.requestDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.requestDateStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 预计处理日期
    expectedDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.expectedDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.expectedDateEnd).getTime() < time.getTime()
            )
          }
        },
      }
    },
    expectedDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.expectedDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.expectedDateStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 实际处理日期
    actualDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.actualDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.actualDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    actualDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.actualDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.actualDateStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 财务确认日期
    finConfirmDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.finConfirmDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.finConfirmDateEnd).getTime() < time.getTime()
            )
          }
        },
      }
    },
    finConfirmDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.finConfirmDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.finConfirmDateStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
